<template>
  <div class="d-flex align-items-center">
    <span :class="`stamp stamp-sm bg-${color} mr-3`">
      <i :class="`fa fa-${icon}`" />
    </span>
    <div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            default: 'question',
        },
        color: {
            type: String,
            default: 'red',
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/asset-register/IconizedInfoComponent.vue